import React from "react";
import { createGlobalStyle } from "styled-components";
import { useDispatch } from "react-redux";
import { AddIon } from "./Add";
import Container from "saur_ui_library/src/Atoms/Container/Container";
import Card from "saur_ui_library/src/Molecules/Card/Card";
import { INCREASE_COUNT } from "../../../redux/actionType";
import Word from "saur_ui_library/src/Atoms/Word/Word";

  const AddSeason= () => {
    //variables 
    // store
    const dispatch = useDispatch();
    //render
  return (
    <Container className="sds-reset-style">
      <Styles />
      <Card className="AddContainer">
         <AddIon className="add-logo" id="add-logo" onclick={()=>{
            dispatch({
              type: INCREASE_COUNT,
              payload: 1,
            });
          }}/>
        <Word
          variant="p"
          className="add-title"
          automatedTestId="add-season"
          textStyle="normalBold"
          value="Ajouter une saison"
        />
      </Card>
    </Container>
  );
};
const Styles = createGlobalStyle`
.sds-reset-style{
.AddContainer{
  height: 486px;
  width: fit-content;
  padding: 40px;
  background-color:#F5F8FB;
  .add-logo{
    margin-left: auto;
    margin-right: auto;
    margin-top: 70px;
  }
  .add-title{
    margin-top: 30px;
    
  }
}
}
 
`;
export default AddSeason;
